function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';

var PageWrapper = function PageWrapper(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'column' : _ref$direction,
      _ref$white = _ref.white,
      white = _ref$white === void 0 ? false : _ref$white,
      _ref$withGutters = _ref.withGutters,
      withGutters = _ref$withGutters === void 0 ? false : _ref$withGutters,
      _ref$withMobileGutter = _ref.withMobileGutters,
      withMobileGutters = _ref$withMobileGutter === void 0 ? false : _ref$withMobileGutter;
  var mergedClassName = classNames(styles.pageWrapper, className, (_classNames = {}, _defineProperty(_classNames, styles[direction], !!direction), _defineProperty(_classNames, styles.white, white), _defineProperty(_classNames, styles.withGutters, withGutters), _defineProperty(_classNames, styles.withMobileGutters, withMobileGutters), _classNames));
  return /*#__PURE__*/React.createElement("div", {
    className: mergedClassName
  }, children);
};

export default PageWrapper;